import React, {
  FC,
  PropsWithChildren,
  useCallback,
  useEffect,
  useState,
} from 'react'
import cn from 'classnames'

import styles from './AnimatedCollapse.module.scss'

interface IAnimatedCollapseProps {
  className?: string
  isVisible: boolean
}

export const AnimatedCollapse: FC<
  PropsWithChildren<IAnimatedCollapseProps>
> = ({ className, isVisible, children }) => {
  const [withOverflowHidden, setWithOverflowHidden] = useState(!isVisible)

  useEffect(() => {
    // При скрытие - сразу вешаем overflow
    if (!isVisible) {
      setWithOverflowHidden(true)
    }
  }, [isVisible])

  // Обработчик окончания анимации
  const handleTransitionEnd = useCallback(() => {
    if (isVisible) {
      setWithOverflowHidden(false)
    }
  }, [isVisible])

  return (
    <div
      className={cn(styles.container, className, {
        [styles.isVisible]: isVisible,
      })}
      onTransitionEnd={handleTransitionEnd}
    >
      <div
        className={cn(styles.content, {
          [styles.isOverflowHidden]: withOverflowHidden,
        })}
      >
        {children}
      </div>
    </div>
  )
}
